const Header = () => {
    return <div className="header">
        <div className="def">

            <div className="dee-header">
                <div className="circle-header"></div>
            </div>
            <p className="ef">
                EF
            </p>

        </div>
        <div className="right-side">
            <div className="arch">planning+architecture</div>
            <div className="menu">menu</div>
        </div>
    </div>
}

export default Header